import { render, staticRenderFns } from "./ProfilEdit.vue?vue&type=template&id=306dafb4&scoped=true"
import script from "./ProfilEdit.vue?vue&type=script&lang=js"
export * from "./ProfilEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306dafb4",
  null
  
)

export default component.exports